import type {IssueEventInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'

export function AssignedText({info}: {info: IssueEventInfo}) {
  const {eventType, assigneeLogin} = info
  if (!assigneeLogin) return <>{eventType}</>
  return (
    <>
      {eventType} <strong>{assigneeLogin}</strong>
    </>
  )
}
